import { call, put } from 'redux-saga/effects';
import { retriable } from '../retriable';
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
    isValidFunction,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import {
    COST_ACCOUNTING_ACTION_FAILURE,
    COST_ACCOUNTING_ACTION_SUCCESS,
    FETCH_COST_ACCOUNTING_AUDIT_FAILURE,
    FETCH_COST_ACCOUNTING_AUDIT_SUCCESS,
    FETCH_COST_ACCOUNTING_ENTRIES_FAILURE,
    FETCH_COST_ACCOUNTING_ENTRIES_SUCCESS,
    FETCH_COST_ACCOUNTING_PERIODS_FAILURE,
    FETCH_COST_ACCOUNTING_PERIODS_SUCCESS,
    FETCH_COST_ACCOUNTING_PROFITABILITY_FAILURE,
    FETCH_COST_ACCOUNTING_PROFITABILITY_SUCCESS,
} from '../../redux/modules/costAccounting/costAccounting-actions';

function* handleFailure(e, action, failureType, message) {
    if (isValidFunction(action.failureCallBack)) {
        action.failureCallBack();
    }
    if (didApiCallFailDueToUnauthorizedUser(e)) {
        yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
    } else if (didApiCallFailDueToVersionMismatch(e)) {
        yield put({ type: MISMATCH_IN_VERSION });
    } else {
        yield put({ type: ERROR_MESSAGE, message: `${message}: ${getErrorMessage(e)}` });
    }
    yield put({ type: failureType });
    yield put({ type: HIDE_SPINNER, state: { canShow: false } });
}

export function* fetchCostAccountingPeriodsWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().get, action.api);
        yield put({
            type: FETCH_COST_ACCOUNTING_PERIODS_SUCCESS,
            data: response.data,
            page: action.page,
            size: action.size,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        yield handleFailure(e, action, FETCH_COST_ACCOUNTING_PERIODS_FAILURE, 'Cost accounting periods fetch failed');
    }
}

export function* fetchCostAccountingEntriesWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().get, action.api);
        yield put({
            type: FETCH_COST_ACCOUNTING_ENTRIES_SUCCESS,
            data: response.data,
            periodUuid: action.periodUuid,
            state: action.state,
            sourceType: action.sourceType,
            sourceId: action.sourceId,
            page: action.page,
            size: action.size,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        yield handleFailure(e, action, FETCH_COST_ACCOUNTING_ENTRIES_FAILURE, 'Cost accounting entries fetch failed');
    }
}

export function* fetchCostAccountingAuditWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().get, action.api);
        yield put({
            type: FETCH_COST_ACCOUNTING_AUDIT_SUCCESS,
            data: response.data,
            page: action.page,
            size: action.size,
            auditFetchKey: action.auditFetchKey,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        yield handleFailure(e, action, FETCH_COST_ACCOUNTING_AUDIT_FAILURE, 'Cost accounting audit fetch failed');
    }
}

export function* fetchCostAccountingProfitabilityWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().get, action.api);
        yield put({ type: FETCH_COST_ACCOUNTING_PROFITABILITY_SUCCESS, data: response.data });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        yield handleFailure(e, action, FETCH_COST_ACCOUNTING_PROFITABILITY_FAILURE, 'Cost accounting profitability fetch failed');
    }
}

export function* costAccountingActionWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const client = retriable();
        const response = yield call(client[action.method || 'post'], action.api, action.payload);
        yield put({ type: COST_ACCOUNTING_ACTION_SUCCESS, data: response.data });
        yield put({ type: SUCCESS_MESSAGE, message: 'Cost accounting action completed' });
        if (isValidFunction(action.successCallback)) {
            action.successCallback(response.data);
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        yield handleFailure(e, action, COST_ACCOUNTING_ACTION_FAILURE, 'Cost accounting action failed');
    }
}
